import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { v4 as uid } from 'uuid';
import { AxiosResponse } from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ContainerInsumos } from './styled';
import { NavegacaoDrawer } from '../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled';

//APP
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado';
import { listMedidas, tryError } from '../../../../services/Afins';
import { getCategoriaMarcaInsumo } from '../../../../services/config/marca';
import { getFormulacao, TypeFormulacao } from '../../../../services/recomendacao/formulacao';
import { getRecomendaAtivos, TypeRecomendaAtivos } from '../../../../services/recomendacao/ativos';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert';
import { getCategoriaInsumo, getCategoriaProdutos, TypeCategoriaProdutos } from '../../../../services/categoriaProdutos';
import { delInsumos, getInsumos, InsumosItens, postInsumos, putInsumos, TypeInsumos } from '../../../../services/recomendacao/insumos';

//COMPONENTS
import ViewPage from '../../../../Components/ViewPage';
import ButtonCustom from '../../../../Components/ButtonCustom';
import FormInsumoNovo, { TypeInsetAtivos } from './components/formulario';
import { TitleH1 } from '../../../../Components/CustomUi/titleH1';
import { TypeEditAlvo } from '../../../../Components/recomendacao/insumos';
import { TabelaInsumos } from './components/tabela';
import { useGetCategoriaProdutos, useGetInsumosDefensivos } from '../../../../services/catalogosInsumos/defensivos/GET';
import { useDeleteInsumoDefensivo } from '../../../../services/catalogosInsumos/defensivos/DELETE';
import { usePostInsumoDefensivo } from '../../../../services/catalogosInsumos/defensivos/POST';
import { usePutEditarInsumoDefensivo, usePutRemoverInsumoComposicao } from '../../../../services/catalogosInsumos/defensivos/PUT';

const CatalogoDefensivos: React.FC = () => {

  //#region STATES
  const [visibleForm, setVisibleForm] = useState(false);
  const [update, setUpdate] = useState(0);
  const [permissions, setPermissions] = useState<ItensPerUserLogged>();
  const [clone, setClone] = useState(0);
  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [buscarTabela, setBuscarTabela] = useState('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [buscaDebounced, setBuscaDebounced] = useState('')
  //FORMULARIO
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<'Dados do insumo' | 'Composição' | 'Aplicação'>('Dados do insumo')
  const [loadingForm, setLoadingForm] = useState(false);
  const [nome, setNome] = useState('');
  const [categoria, setCategoria] = useState<string>('');
  const [categoriaId, setCategoriaId] = useState<number>(null);
  const [classeAgro, setClasseAgro] = useState<string>('');
  const [classeAgroId, setClasseAgroId] = useState<number>(null);
  const [fabricante, setFabricante] = useState<string>('');
  const [fabricanteId, setFabricanteId] = useState<number>(null);
  const [formulacao, setFormulacao] = useState<string>('');
  const [formulacaoId, setFormulacaoId] = useState<number>(null);
  const [unidadeDose, setUnidadeDose] = useState<string>('');
  const [unidadeDoseId, setUnidadeDoseId] = useState<number>(null);
  const [observacao, setObservacao] = useState<string>('');
  const [ativo, setAtivo] = useState<string>('');
  const [ativosId, setAtivosId] = useState<number>(null);
  const [ativos, setAtivos] = useState<TypeInsetAtivos[]>([] as TypeInsetAtivos[]);
  const [concentracao, setConcentracao] = useState<string>('');
  const [cultura, setCultura] = useState<string>('');
  const [culturaId, setCulturaId] = useState<number>(null);
  const [faseDeCultura, setFaseDeCultura] = useState<string>('');
  const [faseDeCulturaId, setFaseDeCulturaId] = useState<number>(null);
  const [aplicacoes, setAplicacoes] = useState<InsumosItens['aplicacoes']>([] as InsumosItens['aplicacoes'])
  const [especie, setEspecie] = useState<string>('')
  const [especieId, setEspecieId] = useState<number>(null)
  const [variacaoEspecie, setVariacaoEspecie] = useState<string>('')
  const [variacaoEspecieId, setVariacaoEspecieId] = useState<number>(null)
  const [doseBula, setDoseBula] = useState<string>('')
  const [doseUsual, setDoseUsual] = useState<string>('')
  const [addEspecieAplicacoes, setAddEspecieAplicacoes] = useState([])
  const [alvoSelect, setAlvoSelect] = useState(0)
  const [dataAtivos, setDataAtivos] = useState([])
  const [dataCatCategoria, setDataCatCategoria] = useState([])
  const [dataFabricantes, setDataFabricantes] = useState([])
  const [dataFormulacao, setDataFormulacao] = useState([])
  const [dataUnidadeMedida, setDataUnidadeMedida] = useState([])
  const [doseBulaUpdate, setDoseBulaUpdate] = useState('')
  const [doseUsualUpdate, setDoseUsualUpdate] = useState('')
  const [classe_agronimica_principal, setClasse_agronimica_principal] = useState(null);
  //#endregion

  //#region API
  const { data_insumos_defensivos, total_insumos_defensivos, carregando_insumos_defensivos, refetch_data_insumos_defensivos } = useGetInsumosDefensivos({
    codCategoriaProduto: 1,
    pagination: pagination,
    page: page,
    busca: buscaDebounced !== '' ? buscaDebounced : undefined,
  });
  const { mutate_salvar_insumo_defensivo, carregando_salvar_insumo_defensivo } = usePostInsumoDefensivo();
  const { mutate_editar_insumo_defensivo, carregando_editar_insumo_defensivo } = usePutEditarInsumoDefensivo();
  const { mutate_remover_ativo, carregando_remover_ativo } = usePutRemoverInsumoComposicao();
  const { mutate_excluir_defensivo, carregando_excluir_defensivo } = useDeleteInsumoDefensivo();
  const { data_categoria_produtos } = useGetCategoriaProdutos(20);
  //#endregion

  //#region FUNCTIONS
  function deletarInsumo(cod_insumo_defensivo: number) {
    mutate_excluir_defensivo({
      cod_insumo_defensivo: cod_insumo_defensivo,
      refetch_data_insumos_defensivos: refetch_data_insumos_defensivos,
    })
  }

  const handleClickEdit = (cod) => {
    setUpdate(cod)
    setVisibleForm(true)
  }

  function fecharGaveta() {
    setVisibleForm(false)
    setUpdate(null)
    setClone(null)
    setTab_selecionar_atual('Dados do insumo')
    setNome('')
    setCategoria('')
    setCategoriaId(null)
    setClasseAgro('')
    setClasseAgroId(null)
    setFabricante('')
    setFabricanteId(null)
    setFormulacao('')
    setFormulacaoId(null)
    setUnidadeDose('')
    setUnidadeDoseId(null)
    setObservacao('')
    setAtivo('')
    setAtivosId(null)
    setConcentracao('')
    setAtivos([])
    setCultura('')
    setCulturaId(null)
    setFaseDeCultura('')
    setFaseDeCulturaId(null)
    setEspecie('')
    setEspecieId(null)
    setVariacaoEspecie('')
    setVariacaoEspecieId(null)
    setDoseBula('')
    setDoseBulaUpdate('')
    setDoseUsual('')
    setDoseUsualUpdate('')
    setAplicacoes([])
  }

  const handleClickClone = (cod) => {
    setClone(cod)
    setVisibleForm(true)
  }

  const handleChangeClasse = async (codCategoriaProduto) => {
    setClasseAgroId(codCategoriaProduto)
    const resp: AxiosResponse<TypeRecomendaAtivos> = await getRecomendaAtivos({
      codCategoriaProduto,
      pagination: -1,
    })

    const catego = (data_categoria_produtos ?? []).find((data) => codCategoriaProduto === data.cod)
    if (catego?.cod_categoria === 10) {
    }

    setDataAtivos(resp.data.itens)
  }

  const updateAlvo = async (codEspecie, codVariacao, i, codAplicacao, index, cod, dados) => {
    const aplica = JSON.parse(JSON.stringify(aplicacoes))
    setDoseBulaUpdate(dados?.dose_bula)
    setDoseUsualUpdate(dados?.dose_usual)
    const fields: TypeEditAlvo = {
      cod,
      dose_bula: Number(`${String(doseBulaUpdate)?.replace(',', '.')}`),
      dose_usual: Number(`${String(doseUsualUpdate)?.replace(',', '.')}`),
      // medida: form.getFieldValue(`medida${alvoSelect}`),
      cod_especie: codEspecie,
      cod_variacao_especie: codVariacao,
    }

    if (update > 0) {
      loadingAlert({ msg: 'Salvando alterações...', id: 'save_alter' })
      const resp: AxiosResponse<TypeInsumos> = await putInsumos(
        update,
        {
          aplicacoes: [
            {
              cod: codAplicacao,
              alvos: [fields],
            },
          ],
        },
        { embed: 'aplicacoes,alvos,composicao' }
      )

      if (resp?.status === 200 || resp?.status === 204) {
        successAlert('Alvo atualizado com sucesso!', 5000, 'save_alter')

        editInsumo(resp.data.itens[0].cod)
        setAlvoSelect(0)
      }

      if (resp?.status === 400) {
        errorAlert('Falha na operação!', 5000, 'save_alter')
      }
    } else {
      aplica[index].alvos[i] = fields
      setAplicacoes(aplica)
      destroyAlert('save_alter')
    }
    setDoseBulaUpdate('')
    setDoseUsualUpdate('')
    destroyAlert('save_alter')
  }

  const removeAlvo = async (cod, codAplicacao, index: number) => {
    if (typeof cod === 'string') {
      setAplicacoes((prev) =>
        prev.map((item) => ({
          ...item,
          alvos: item.alvos.filter((u) => u.cod !== cod),
        }))
      )
    } else {
      try {
        const remove = () => {
          const dados = [...aplicacoes]
          dados.map((data) => {
            if (data.cod === codAplicacao) {
              data.alvos = data.alvos.filter((alvo) => alvo.cod !== cod)
            }
            return data
          })
          successAlert('Alvo removido com sucesso!')
          setAplicacoes(dados)
        }

        if (update === 0) {
          remove()
        } else {
          loadingAlert({ msg: 'Removendo...', id: 'remove_2' })
          const resp = await putInsumos(
            update,
            {
              aplicacoes: [
                {
                  cod: codAplicacao,
                  alvos_remover: [cod],
                },
              ],
            },
            { embed: 'aplicacoes,alvos,composicao' }
          )

          if (resp.status === 200) {
            remove()
            destroyAlert('remove_2')
          }

          if (resp.status === 400) {
            destroyAlert('remove_2')
          }
        }
      } catch (error) {
        tryError(error)
        destroyAlert('remove_2')
      }
    }
  }

  const editInsumo = async (cod) => {
    setLoadingForm(true)
    loadingAlert({ msg: 'Carregando insumo...', id: 'load_ativos' })
    const resp: AxiosResponse<TypeInsumos> = await getInsumos({
      cod,
      embed: 'aplicacoes,alvos,composicao',
    })

    const dados = resp.data.itens[0]

    handleChangeClasse(dados.cod_categoria_produto)

    let composicao: TypeInsetAtivos[] = []

    dados.composicao.forEach((data) => {
      composicao = [
        ...composicao,
        {
          uid: uid(),
          cod: data.cod,
          concentracao: data.concentracao,
          cod_ativo: data.cod_ativo,
          nomeAtivo: data.ativo_nome,
          ativo: data.ativo
        },
      ]
    })

    const aplica = dados.aplicacoes.map((rec) => {
      if (clone > 0) {
        rec.cod = uid()
      }

      rec.alvos.map((item) => {
        if (clone > 0) {
          item.cod = uid()
        }
        item.cod_cultura = rec.cod_cultura
        return item
      })
      return rec
    })

    const formulacao_nome = dataFormulacao?.filter((item) => item?.cod === dados?.cod_formulacao)
    const medida_aplicacao_nome = dataUnidadeMedida?.filter(
      (rec) => rec?.cod === dados?.cod_medida_aplicacao
    )

    setAplicacoes(aplica)
    setAtivos(composicao)
    setNome(dados.nome)
    setCategoria(dados.categoria_produto_nome)
    setCategoriaId(dados.cod_categoria_produto)
    setClasseAgro(dados.classe_agronomica_nome)
    setClasseAgroId(dados.cod_classe_agronomica)
    setFabricante(dados.fabricante_nome)
    setFabricanteId(dados.cod_fabricante)
    setFormulacao(formulacao_nome[0]?.nome)
    setFormulacaoId(dados.cod_formulacao)
    setUnidadeDose(medida_aplicacao_nome[0]?.nome)
    setUnidadeDoseId(dados.cod_medida_aplicacao)
    setObservacao(dados.observacao)
    setClasse_agronimica_principal(dados.cod_classe_agronomica)

    destroyAlert('load_ativos')
    setLoadingForm(false)
  }

  const adicionarAtivos = async () => {
    const nomeAtivo = dataAtivos.find((data) => data.cod === ativosId)

    const check = ativos.find((data) => data.cod_ativo === ativosId)

    if (check !== undefined) {
      errorAlert('Ativo já inserido!')

      return
    }

    setAtivos([
      ...ativos,
      {
        uid: uid(),
        cod: null,
        cod_ativo: ativosId,
        nomeAtivo: nomeAtivo.nome,
        concentracao: Number(concentracao.replace(',', '.')),
        ativo: nomeAtivo.ativo
      },
    ])
    if (update > 0) {
    }
    setAtivo('')
    setConcentracao('')
  }

  //#region SALVAR INSUMO
  function salvarInsumos() {
    const salvar_ativos = ativos.map((item) => {
      return {
        cod_ativo: item.cod_ativo,
        concentracao: item.concentracao
      }
    });
    mutate_salvar_insumo_defensivo({
      nome: nome,
      cod_fabricante: fabricanteId,
      cod_categoria_produto: 1,
      cod_classe_agronomica: classeAgroId,
      cod_formulacao: formulacaoId,
      adjuvante: undefined,
      cod_medida_aplicacao: unidadeDoseId,
      observacao: observacao,
      // @ts-ignore
      ativos: salvar_ativos,
      // @ts-ignore
      aplicacoes: aplicacoes,
      refetch_data_insumos_defensivos: refetch_data_insumos_defensivos,
      fecharGaveta: fecharGaveta
    });
  };
  //#endregion

  //#region EDITAR INSUMO
  function editarInsumos() {
    const salvar_ativos = ativos.map((item) => {
      return {
        cod_ativo: item.cod_ativo,
        concentracao: item.concentracao
      }
    });
    mutate_editar_insumo_defensivo({
      cod_insumo_defensivo: update,
      nome: nome,
      cod_fabricante: fabricanteId,
      cod_categoria_produto: 1,
      cod_classe_agronomica: classeAgroId,
      cod_formulacao: formulacaoId,
      adjuvante: undefined,
      cod_medida_aplicacao: unidadeDoseId,
      observacao: observacao,
      // @ts-ignore
      ativos: salvar_ativos,
      // @ts-ignore
      aplicacoes: aplicacoes,
      refetch_data_insumos_defensivos: refetch_data_insumos_defensivos,
      fecharGaveta: fecharGaveta
    });
  };

  //refazer essa requisição (editInsumo(resp.data.itens[0].cod)) após editar não faz sentido, 
  //então não faço a requisição na versão refatorada( editarInsumos() )!
  //mas vou deixar esse código ainda, para caso ocorra algum bug relacionado
  //eu consigo relembrar com era! (22/05/2026)
  const salvarInsumosOld = async () => {
    const dataAtivos = [...ativos]
    // eslint-disable-next-line camelcase
    let tempAtivo: { cod_ativo: number; concentracao: number }[] = []
    dataAtivos.forEach((ativo) => {
      tempAtivo = [
        ...tempAtivo,
        {
          cod_ativo: ativo.cod_ativo,
          concentracao: ativo.concentracao,
        },
      ]
      return tempAtivo
    })

    let dataFim: InsumosItens = {
      nome: nome,
      cod_fabricante: fabricanteId,
      cod_categoria_produto: 1,
      cod_classe_agronomica: classeAgroId,
      cod_formulacao: formulacaoId,
      adjuvante: undefined,
      cod_medida_aplicacao: unidadeDoseId,
      observacao: observacao,
      // @ts-ignore
      ativos: tempAtivo,
      aplicacoes,
    }

    try {
      loadingAlert({ msg: 'Salvando...', id: 'save_ativo' })
      if (update <= 0 || clone > 0) {
        const resp = await postInsumos(dataFim)

        if (resp.status === 201) {
          successAlert('Insumo salvo com sucesso!', 5000, 'save_ativo')
          fecharGaveta()
          setAtivos([] as TypeInsetAtivos[])
          setAplicacoes([])
          setTab_selecionar_atual('Dados do insumo')
          refetch_data_insumos_defensivos()
        }
      } else {
        const resp = await putInsumos(update, dataFim)

        if (resp.status === 200) {
          successAlert('Insumo atualizado com sucesso!', 5000, 'save_ativo')
          editInsumo(resp.data.itens[0].cod)
          fecharGaveta()
          refetch_data_insumos_defensivos()
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação!', 7000, 'save_ativo')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!', 7000, 'save_ativo')
          })
        }
      } else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'save_ativo')
      }
    }
  }
  //#endregion

  //#TODO como a lista é feita pela requisição (feito pelo outro Dev), ao remover um item
  // essa função precisa ser chamada para remover o item do front sem, precisar refazer a requisição
  // PRECISA REFATORAR ESSA MALUQUICE!!! (22/05/2026)
  function atualizarListaAtivosComposicao(uid, cod = null) {
    const dados = [...ativos]
    let filtro = [];
    if (cod === null) {
      filtro = dados.filter((data) => data.uid !== uid)
    }
    filtro = dados.filter((data) => data.uid !== uid);
    setAtivos(filtro)
  }

  const handleRemoveAtivo = async (uid, cod = null, remover_localmente: boolean) => {
    const dados = [...ativos]
    let filtro = []
    if (cod === null || remover_localmente) {
      filtro = dados.filter((data) => data.uid !== uid)
      setAtivos(filtro)
    } else {
      mutate_remover_ativo({
        cod_insumo_defensivo: update,
        ativos_remover: [cod],
        atualizarListaAtivosComposicao: () => atualizarListaAtivosComposicao(uid, cod = null),
        refetch_data_insumos_defensivos: refetch_data_insumos_defensivos
      })
    }
  }

  async function listCatInsumos() {
    const resp: AxiosResponse = await getCategoriaInsumo({})

    setDataCatCategoria(resp.data.itens)
  }

  const listFabricantes = async () => {
    const resp = await getCategoriaMarcaInsumo()
    setDataFabricantes(resp.data.itens)
  }

  const listFormulacao = async () => {
    const resp: AxiosResponse<TypeFormulacao> = await getFormulacao({
      pagination: -1,
    })

    setDataFormulacao(resp.data.itens)
  }

  const listUnidadeMedida = async () => {
    const resp = await listMedidas()

    setDataUnidadeMedida(resp)
  }

  useEffect(() => {
    if (update > 0) {
      editInsumo(update)
    }
  }, [update])

  useEffect(() => {
    if (clone > 0) {
      editInsumo(clone)
    }
  }, [clone])

  useEffect(() => {
    listCatInsumos()
    listFabricantes()
    listFormulacao()
    listUnidadeMedida()
  }, [])


  useEffect(() => {
    const handler = setTimeout(() => {
      if (buscarTabela.length > 2 || buscarTabela === '') {
        setBuscaDebounced(buscarTabela)
      }
    }, 700)

    return () => {
      clearTimeout(handler)
    }
  }, [buscarTabela])

  return (
    <ContainerInsumos>
      <ViewPage
        title='Catálogo insumos'
        onPermission={setPermissions}
        rotina={38}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        newHide
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Defensivos</TitleH1>
        </div>
        <TabelaInsumos
          loading={carregando_insumos_defensivos}
          list_insumos={data_insumos_defensivos ?? []}
          permissions={permissions}
          deletar={deletarInsumo}
          abrir={() => setVisibleForm(true)}
          editar={handleClickEdit}
          clone={handleClickClone}
          page={page}
          setPage={setPage}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          setPagination={setPagination}
          total={total_insumos_defensivos}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={carregando_excluir_defensivo}
          setFake_loading={setFake_loading}
        />

        <Drawer
          width={800}
          open={visibleForm}
          onClose={fecharGaveta}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={update > 0 ? editarInsumos : salvarInsumos}
                loading={carregando_salvar_insumo_defensivo || carregando_editar_insumo_defensivo}
                disabled={carregando_salvar_insumo_defensivo || carregando_editar_insumo_defensivo}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={fecharGaveta}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <FormInsumoNovo
            update={update}
            criadoPorAtualizadoPor={''}
            loadingForm={loadingForm}
            tab_selecionar_atual={tab_selecionar_atual}
            setTab_selecionar_atual={setTab_selecionar_atual}
            permissions={permissions}
            nome={nome}
            setNome={setNome}
            categoria_insumo={categoria}
            setCategoria_insumo={setCategoria}
            categoria_insumoId={categoriaId}
            setCategoria_insumoId={setCategoriaId}
            classeAgro={classeAgro}
            setClasseAgro={setClasseAgro}
            classeAgroId={classeAgroId}
            setClasseAgroId={setClasseAgroId}
            fabricante={fabricante}
            setFabricante={setFabricante}
            fabricanteId={fabricanteId}
            setFabricanteId={setFabricanteId}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            formulacaoId={formulacaoId}
            setFormulacaoId={setFormulacaoId}
            unidadeDose={unidadeDose}
            setUnidadeDose={setUnidadeDose}
            unidadeDoseId={unidadeDoseId}
            setUnidadeDoseId={setUnidadeDoseId}
            observacao={observacao}
            setObservacao={setObservacao}
            ativo={ativo}
            setAtivo={setAtivo}
            ativos={ativos}
            setAtivos={setAtivos}
            ativosId={ativosId}
            setAtivoId={setAtivosId}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            cultura={cultura}
            setCultura={setCultura}
            culturaId={culturaId}
            setCulturaId={setCulturaId}
            faseDeCultura={faseDeCultura}
            setFaseDeCultura={setFaseDeCultura}
            faseDeCulturaId={faseDeCulturaId}
            setFaseDeCulturaId={setFaseDeCulturaId}
            aplicacoes={aplicacoes}
            setAplicacoes={setAplicacoes}
            especieNome={especie}
            setEspecieNome={setEspecie}
            especieId={especieId}
            setEspecieId={setEspecieId}
            variacaoEspecie={variacaoEspecie}
            setVariacaoEspecie={setVariacaoEspecie}
            variacaoEspecieId={variacaoEspecieId}
            setVariacaoEspecieId={setVariacaoEspecieId}
            doseBula={doseBula}
            setDoseBula={setDoseBula}
            doseUsual={doseUsual}
            setDoseUsual={setDoseUsual}
            alvoSelect={alvoSelect}
            setAlvoSelect={setAlvoSelect}
            codClone={clone}
            dataCatProduto={data_categoria_produtos ?? []}
            dataCatCategoria={dataCatCategoria}
            dataFabricantes={dataFabricantes}
            dataFormulacao={dataFormulacao}
            dataUnidadeMedida={dataUnidadeMedida}
            handleChangeClasse={handleChangeClasse}
            dataAtivos={dataAtivos}
            doseBulaUpdate={doseBulaUpdate}
            setDoseBulaUpdate={setDoseBulaUpdate}
            doseUsualUpdate={doseUsualUpdate}
            setDoseUsualUpdate={setDoseUsualUpdate}
            adicionarAtivos={adicionarAtivos}
            updateAlvo={updateAlvo}
            handleRemoveAtivo={handleRemoveAtivo}
            removeAlvo={removeAlvo}
            classe_agronimica_principal={classe_agronimica_principal}
            carregando_remover_ativo={carregando_remover_ativo}
          />
        </Drawer>
      </ViewPage>
    </ContainerInsumos>
  )
}

export default CatalogoDefensivos
